import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { FP } from "./tokens";

/**
 * Estado vacío estándar: ícono + título + guía de qué hacer.
 * Úsese directo en cards/listas o como noRowsOverlay (FpDataGrid ya lo trae).
 */
export default function EstadoVacio({
  icono: Icono = InboxOutlinedIcon,
  titulo = "No hay datos para mostrar",
  subtitulo,
  accion = null,
  compacto = false,
}) {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: compacto ? 3 : 6,
        px: 2,
        gap: 0.6,
      }}
    >
      <Box
        sx={{
          width: 52,
          height: 52,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: FP.color.surfaceAlt,
          color: FP.color.textSecondary,
          mb: 0.6,
        }}
      >
        <Icono sx={{ fontSize: 26 }} />
      </Box>
      <Typography sx={{ fontWeight: 800, color: FP.color.textPrimary, fontSize: compacto ? "0.95rem" : "1.05rem" }}>
        {titulo}
      </Typography>
      {subtitulo ? (
        <Typography sx={{ color: FP.color.textSecondary, fontSize: "0.85rem", maxWidth: 420 }}>{subtitulo}</Typography>
      ) : null}
      {accion}
    </Box>
  );
}
